import { render, staticRenderFns } from "./ComponentTemplate.vue?vue&type=template&id=06476438&scoped=true"
import script from "./ComponentTemplate.vue?vue&type=script&lang=js"
export * from "./ComponentTemplate.vue?vue&type=script&lang=js"
import style0 from "./ComponentTemplate.vue?vue&type=style&index=0&id=06476438&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06476438",
  null
  
)

export default component.exports